// IOS 唤起app 商店
export const IOS_APP_STORE =
  'https://apps.apple.com/jp/app/moox-ai%E7%95%B0%E4%B8%96%E7%95%8C%E3%81%AE%E9%9F%BF%E3%81%8D/id6757943635'
// Android 唤起app scheme
export const ANDROID_SCHEME = 'pengpeng://gotomaintab?tab=home'
// Android 唤起app 商店
export const ANDROID_PLAY_STORE =
  'https://play.google.com/store/apps/details?id=com.pixelmuse.aimoox&hl=ja'

// 测试环境 - Google 客户端 ID
export const GOOGLE_CLIENT_ID_TEST =
  '429145174772-64396slreudvs9gij701054eu9q3erkv.apps.googleusercontent.com'

// 生产环境 - Google 客户端 ID
export const GOOGLE_CLIENT_ID_PROD =
  '429145174772-64396slreudvs9gij701054eu9q3erkv.apps.googleusercontent.com'

// LINE Login Channel ID（前端可用；Channel Secret 必须只放后端）
// TODO: 请填入各环境的 Channel ID（或改为从配置注入）
export const LINE_CHANNEL_ID_TEST = '2008799107'
export const LINE_CHANNEL_ID_PROD = '2008799107'

// Apple Sign In Client ID (Service ID)
export const APPLE_CLIENT_ID_TEST = 'com.aimoox.signin'
export const APPLE_CLIENT_ID_PROD = 'com.aimoox.signin'

// 媒体服务内部鉴权 token
export const MEDIA_INTERNAL_TOKEN = '9678fa54dc9751a0633fe25843f900b4'
// 隐私政策
export const PRIVACY_POLICY_URL =
  'https://h5-character.xunlei.com/help/privacyPolicy'
// 用户服务
export const USER_SERVICE_URL =
  'https://h5-character.xunlei.com/help/userService'

export const STAT_TYPE_SOURCE = {
  home: 'home', // 从首页流
}

// 存储的key
export const LOCAL_STORAGE_KEY_DID = 'did'

// 显示头部的路径映射
export const SHOW_HEADER_MAP = {
  '/': true,
}
// 显示底部的路径映射
export const SHOW_FOOTER_MAP = {
  '/': true,
}
// 显示主页面的背景映射
export const SHOW_HOME_BG_MAP = {
  '/': true,
}
// 移动端断点
export const MOBILE_BREAKPOINT = 768
// 窗口大小变化节流延迟时间
export const RESIZE_THROTTLE_DELAY = 200

// 首页背景图 - WEB
export const IMG_HOME_WEB_BG =
  'https://bd-xc-web.ixiaochuan.cn/zuiyou/3977942a_1j8pstooa_6_.png'
// 首页背景图 - MOBILE
export const IMG_HOME_MOBILE_BG =
  'https://bd-xc-web.ixiaochuan.cn/zuiyou/958187cb_1j8q849ku_1_.png'
